<template>
  <div class="home container text-center">
    <h1 class="page-header">Welcome to Stranger Chat!</h1>
    <router-link to="/chat" class="btn btn-primary">
      <span class="glyphicon glyphicon-comment"></span>
      Chat
    </router-link>
    <br/>
    <br/>
    <p class="lead">
      Users online: {{ this.$parent.onlineUsers }}
    </p>
    <hr/>
    Copyright&copy; Stranger Chat 2018. All rights reserved.
  </div>
</template>

<script>
export default {
  name: 'home',
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Home.vue